"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LeafIcon;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeafIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement("path", { d: "M12.2442 18.9958L12 19C10.2085 19 8.41708 18.3166 7.05025 16.9497C4.589 14.4885 3.17659 6.40918 4.79289 4.79289C6.40918 3.17659 14.4885 4.589 16.9497 7.05025C19.4435 9.54397 19.6623 13.4511 17.6064 16.1929L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3466 20.0676 18.7794 20.0953 18.3871 19.7903L18.2929 19.7071L16.1929 17.6064L16.1646 17.6275C15 18.4917 13.6279 18.9477 12.2442 18.9958ZM10.1129 8.7097C9.7206 8.40467 9.15337 8.4324 8.79289 8.79289C8.40236 9.18341 8.40236 9.81658 8.79289 10.2071L14.7585 16.1714C15.033 15.9894 15.2936 15.7775 15.5355 15.5355C15.7775 15.2936 15.9894 15.033 16.1714 14.7585L10.2071 8.79289L10.1129 8.7097Z" })
  );
}